import React, { useCallback, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import i18n from 'i18next';

import FormButtonPrimary from "../form/FormButtonPrimary";
import FormButtonSecondary from "../form/FormButtonSecondary";
import FormButtonDanger from "../form/FormButtonDanger";
import useApplyStore from "../../store/useApplyStore";
import useModalStore from "../../store/useModalStore";
import useLoadingStore from "../../store/useLoadingStore";
import useViewStore from "../../store/useViewStore";
import Space from "../core/Space";
import Flex from "../core/Flex";
import ConstantConfig from "../core/BXHeader/config/ConstantConfig";
import withErrorHandling from "../../function/withErrorHandling";
import { TermsAndConditions } from "./Step4_1";
import { basename, isProduction } from "../../setting";
import feWriteLog from "../../function/feWriteLog";
import { useMPGS } from "../../hooks/useMPGS";


const StepNavBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { step, goNextStep, goBackStep, refno, isStep4_1Accepted } = useApplyStore();
  const { step2_1_saveForm, step2_2_saveForm, step2_3_saveForm, step2_4_saveForm, step2_5_saveForm } = useApplyStore();
  const { getMpgsSession, step4_option1 } = useApplyStore();
  const { setLoading } = useLoadingStore();
  const { openModalInfo, openModalConfirm } = useModalStore();
  const { isMobileView } = useViewStore((state) => state);
  const { isStep0Valid, isStep1_1Valid, isStep2_1Valid, isStep2_2Valid, isStep2_3Valid, isStep2_4Valid, isStep2_5Valid, isStep3_1Valid, isStep4_1Valid } = useApplyStore();
  const { completePayment, applicationSubmit, failPayment, setStep } = useApplyStore();
  const { init, pay } = useMPGS({
    onComplete: async (res) => {
      try {
        await completePayment();
        const success = await applicationSubmit();
        if (success) {
          setStep("success");
          window.history.pushState({}, "", `/${basename}/${i18n.language}/apply/success`);
        } else {
          setStep("submitFail");
        }
      } catch (e) {
        setStep("submitFail");
      }
    },
    onCancel: async () => {
      await failPayment();
      setStep("paymentFail");
    },
    onError: async (err) => {
      await failPayment();
      setStep("paymentFail");
    },
  });

  useEffect(() => {
    init();
  }, [init]);
  
  const goBack = () => {
    navigate(-1);
  };

  const save = async () => {
    setLoading(true);

    try {
      if (step === "2_1") {
        await step2_1_saveForm();
        setLoading(false);
        openModalInfo({ title: t("saveSuccess") });
      } else if (step === "2_2") {
        await step2_2_saveForm();
        setLoading(false);
        openModalInfo({ title: t("saveSuccess") });
      } else if (step === "2_3") {
        await step2_3_saveForm();
        setLoading(false);
        openModalInfo({ title: t("saveSuccess") });
      } else if (step === "2_4") {
        await step2_4_saveForm();
        setLoading(false);
        openModalInfo({ title: t("saveSuccess") });
      } else if (step === "2_5") {
        await step2_5_saveForm();
        setLoading(false);
        openModalInfo({ title: t("saveSuccess") });
      } else {
        setTimeout(() => {
          setLoading(false);
          openModalInfo({ title: t("saveSuccess") });
        }, 3000);
      }
    } catch (error) {
      feWriteLog(`Error: ${error.message}`);
      if (error.message === "Unauthorized") {
        openModalInfo({
          id: isProduction ? "pre_auth_error_expiry" : "pre_auth_uat_error_expiry",
          title: t("error:unauthorized.title"),
          text: t("error:unauthorized.message")
        });
        // setStep("loading");
      } else if (error.message === "Network Error") {
        openModalInfo({
          id: isProduction ? "pre_auth_error_network" : "pre_auth_uat_error_network",
          title: t("error:network.title"),
          text: t("error:network.message")
        });
      } else {
        openModalInfo({
          id: isProduction ? "pre_auth_error_unknown" : "pre_auth_uat_error_unknown",
          title: t("error:unknown.title"),
          text: t("error:unknown.message")
        });
      }
      setLoading(false);
    }

  }

  const openStep4_1_TermsAndConditions = () => {
    openModalConfirm({
      title: t("translation:apply.step4_1.termsConditionModal.title"),
      text: <TermsAndConditions />,
      style: {
        content: {
          width: 800
        }
      },
      callback: () => {
        goMPGSPayment();
      }
    });
  }

  const goMPGSPayment = withErrorHandling(async () => {
    setLoading(true);
    const { data } = await getMpgsSession(i18n.language === "ch" ? "zh-hk" : "en_us");
    const { sessionId, merchantId } = data;

    pay(sessionId, "#checkout-container");

    // showMPGSLightBox({ sessionId, merchantId });

    setLoading(false);
  });

  /* eslint-disable */
  // const showMPGSLightBox = (content) => {
  //   const sessionID = content.sessionId;
  //   const merchantID = content.merchantId;
  //   const langCode = i18n.language === "ch" ? "zh-hk" : "en_us";

  //   Checkout.configure({
  //     merchant: merchantID,
  //     session: {
  //       id: sessionID
  //     },
  //     interaction: {
  //       merchant: {
  //         name: 'Blue Cross',
  //       },
  //       displayControl: {
  //         paymentConfirmation: 'SHOW',
  //         billingAddress: 'HIDE',
  //         shipping: 'HIDE',
  //       },
  //       locale: langCode,
  //     }
  //   });
  //   Checkout.showLightbox();
  // }
  /* eslint-enable */

  if (isMobileView) {
    return (
      <StepNavBarContainerMobile>

        {
          step === "0" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep0Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "1_1" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep1_1Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "1_2" && <ButtonPrimary $isMobileView={isMobileView} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_1" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_1Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_2" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_2Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_3" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_3Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_4" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_4Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_5" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_5Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "3_1" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep3_1Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "4_1" && <>
            {
              step4_option1 ?
                <ButtonDanger $isMobileView={isMobileView} disabled={false} onClick={openStep4_1_TermsAndConditions}>{t("translation:apply.step4_1.authorization")}</ButtonDanger>
                :
                <ButtonPrimary $isMobileView={isMobileView} disabled={false} onClick={goNextStep}>{t("next")}</ButtonPrimary>
            }
          </>
        }

        <Space height={20} />

        {
          step !== "-1" &&
          <>
            {
              (step === "1_2" || step === "2_1" || step === "2_2") ?
                <ButtonSecondary $isMobileView={isMobileView} disabled={true}>{t("back")}</ButtonSecondary>
                :
                <ButtonSecondary $isMobileView={isMobileView} onClick={step === "0" ? goBack : goBackStep}>{t("back")}</ButtonSecondary>
            }
          </>
        }

        <Space height={20} />

        {
          (
            !isInStep1(step) &&
            step !== "3_1" &&
            step !== "4_1" &&
            step !== "success"
          )
          &&
          <Flex>
            <SaveButton onClick={save}>
              <ImageSave src={`${process.env.PUBLIC_URL}/images/floppy.png`} alt="Save" />
              <SaveButtonText>{t("save")}</SaveButtonText>
            </SaveButton>
            <ApplicationNumber>{t("refno")}： {refno}</ApplicationNumber>
          </Flex>
        }
      </StepNavBarContainerMobile>
    );
  }

  return (
    <StepNavBarContainer>
      {
        (
          !isInStep1(step) &&
          step !== "3_1" &&
          step !== "4_1" &&
          step !== "success"
        )
          ?
          <Left>
            <SaveButton onClick={save}>
              <ImageSave src={`${process.env.PUBLIC_URL}/images/floppy.png`} alt="Save" />
              <SaveButtonText>{t("save")}</SaveButtonText>
            </SaveButton>
          </Left>
          :
          <Space style={{ flex: 1 }} />
      }

      <Navigation>
        {
          step !== "-1" ?
            <>
              {
                (step === "1_2" || step === "2_1" || step === "2_2") ?
                  <ButtonSecondary $isMobileView={isMobileView} disabled={true}>{t("back")}</ButtonSecondary>
                  :
                  <ButtonSecondary $isMobileView={isMobileView} onClick={step === "0" ? goBack : goBackStep}>{t("back")}</ButtonSecondary>
              }
            </>
            :
            <Space height={45} width={154} />
        }

        {
          step === "0" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep0Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "1_1" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep1_1Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "1_2" && <ButtonPrimary $isMobileView={isMobileView} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_1" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_1Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_2" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_2Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_3" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_3Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_4" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_4Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "2_5" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep2_5Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "3_1" && <ButtonPrimary $isMobileView={isMobileView} disabled={!isStep3_1Valid} onClick={goNextStep}>{t("next")}</ButtonPrimary>
        }

        {
          step === "4_1" && <>
            {
              step4_option1 ?
                <ButtonDanger $isMobileView={isMobileView} disabled={false} onClick={openStep4_1_TermsAndConditions}>{t("translation:apply.step4_1.authorization")}</ButtonDanger>
                :
                <ButtonPrimary $isMobileView={isMobileView} disabled={false} onClick={goNextStep}>{t("next")}</ButtonPrimary>
            }
          </>
        }
      </Navigation>

      {
        (
          !isInStep1(step) &&
          step !== "success"
        )
          ?
          <ApplicationNumber>{t("refno")}： {refno}</ApplicationNumber>
          :
          <Space style={{ flex: 1 }} />
      }
    </StepNavBarContainer>
  );
};

const isInStep1 = (step) => {
  return step === "0" || step === "1_1" || step === "1_2";
}

const StepNavBarContainerMobile = styled.div`

`;

const ButtonPrimary = styled(FormButtonPrimary)`
  ${props => props.$isMobileView && `
    width: 100%;
  `};
`;

const ButtonSecondary = styled(FormButtonSecondary)`
  ${props => props.$isMobileView && `
    width: 100%;
  `};
`;

const ButtonDanger = styled(FormButtonDanger)`
  ${props => props.$isMobileView && `
    width: 100%;
  `};
`;

const StepNavBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
}`;

const Left = styled.div`
  flex: 1;
`;

const ImageSave = styled.img`
  width: 24px;
  height: 24px;
`;

const SaveButton = styled.button`
  flex: 0;
  display: flex;
  align-items: center;
  background-color: transparent;
  border-radius: 10px;
  color: var(--aia-bx-blue-2);
  gap: 3px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 10px;

  &:hover {
    background-color: var(--aia-bx-bright-blue-5);
  }
`;

const SaveButtonText = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  margin-left: 3px;
  text-wrap: nowrap;
  color: var(--aia-bx-dark-blue);
`;

const Navigation = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  // width: 342px;
`;

const ApplicationNumber = styled.div`
  flex: 1;
  color: var(--aia-bx-gray-50);
  font-size: 14px;
  text-align: right;
`;

export default StepNavBar;